// Função para validar CPF
function validarCPF(cpf: string) {
  cpf = cpf.replace(/\D/g, ''); // Remove caracteres não numéricos

  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
    return false; // CPF com todos os dígitos iguais é inválido
  }

  // Validação do primeiro dígito
  let soma = 0;
  let peso = 10;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * peso--;
  }
  let digito1 = 11 - (soma % 11);
  if (digito1 === 10 || digito1 === 11) digito1 = 0;
  if (digito1 !== parseInt(cpf.charAt(9))) return false;

  // Validação do segundo dígito
  soma = 0;
  peso = 11;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * peso--;
  }
  let digito2 = 11 - (soma % 11);
  if (digito2 === 10 || digito2 === 11) digito2 = 0;
  if (digito2 !== parseInt(cpf.charAt(10))) return false;

  return true;
}

const tamanhoCNPJSemDV: number = 12;
const regexCNPJSemDV: RegExp = /^([A-Z\d]){12}$/;
const regexCNPJ: RegExp = /^([A-Z\d]){12}(\d){2}$/;
const regexCaracteresMascara: RegExp = /[./-]/g;
const regexCaracteresNaoPermitidos: RegExp = /[^A-Z\d./-]/i;
const valorBase: number = '0'.charCodeAt(0);
const pesosDV: number[] = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const cnpjZerado: string = '00000000000000';

function calculaDV(cnpj: string): string {
  if (!regexCaracteresNaoPermitidos.test(cnpj)) {
    if (regexCNPJSemDV.test(cnpj) && cnpj !== cnpjZerado.substring(0, tamanhoCNPJSemDV)) {
      let somatorioDV1 = 0;
      let somatorioDV2 = 0;
      for (let i = 0; i < tamanhoCNPJSemDV; i++) {
        const asciiDigito = cnpj.charCodeAt(i) - valorBase;
        somatorioDV1 += asciiDigito * pesosDV[i + 1];
        somatorioDV2 += asciiDigito * pesosDV[i];
      }
      const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11);
      somatorioDV2 += dv1 * pesosDV[tamanhoCNPJSemDV];
      const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11);
      return `${dv1}${dv2}`;
    }
  }
  return 'false';
}

// Função para validar CNPJ
function validarCNPJ(cnpj: string) {
  if (!regexCaracteresNaoPermitidos.test(cnpj)) {
    if (regexCNPJ.test(cnpj) && cnpj !== cnpjZerado) {
      const dvInformado = cnpj.substring(tamanhoCNPJSemDV);
      const dvCalculado = calculaDV(cnpj.substring(0, tamanhoCNPJSemDV));
      return dvInformado === dvCalculado;
    }
  }
  return false;
}

// Função que valida CPF ou CNPJ dependendo do tamanho da entrada
export function validarDocumento(documento: string) {
  documento = documento.replace(regexCaracteresMascara, ''); // Remove caracteres . e -
  if (documento.length === 11) {
    return validarCPF(documento); // Chama a função de validação de CPF
  } else if (documento.length === 14) {
    return validarCNPJ(documento); // Chama a função de validação de CNPJ
  } else {
    return false; // Caso o documento não tenha nem 11 nem 14 dígitos
  }
}
